// packages/world-model/src/traits/light-source/index.ts

export { LightSourceTrait } from './lightSourceTrait';
export { LightSourceBehavior } from './lightSourceBehavior';
